import { MouseEvent as ReactMouseEvent, useEffect, useRef, useState } from 'react';

interface UseResizableWidthOptions {
  defaultWidth: number;
  minWidth: number;
  maxWidth: number;
}

const useResizableWidth = ({ defaultWidth, minWidth, maxWidth }: UseResizableWidthOptions) => {
  const [width, setWidth] = useState(defaultWidth);
  const dragStartX = useRef(0);
  const dragStartWidth = useRef(0);
  const boundsRef = useRef({ minWidth, maxWidth });

  useEffect(() => {
    boundsRef.current = { minWidth, maxWidth };
  }, [minWidth, maxWidth]);

  const handleResizeStart = (event: ReactMouseEvent) => {
    event.preventDefault();
    dragStartX.current = event.clientX;
    dragStartWidth.current = width;
    document.body.style.userSelect = 'none';

    const handleMouseMove = (moveEvent: MouseEvent) => {
      const { minWidth: min, maxWidth: max } = boundsRef.current;
      const delta = dragStartX.current - moveEvent.clientX;
      setWidth(Math.min(max, Math.max(min, dragStartWidth.current + delta)));
    };
    const handleMouseUp = () => {
      document.body.style.userSelect = '';
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
  };

  return { width, handleResizeStart };
};

export default useResizableWidth;
